import {
  FromAccountModel,
  PolicyActTypeEnum,
  PolicyFromTypeEnum,
  PolicyItemModel,
  PolicyToTypeEnum,
  PolicyTypeEnum,
} from '@/constants/enum'
import { useTranslation } from '@/services/i18n'
import { getconditionText } from '@/utils/setting'
import StaticApprovalFlow from '@/views/Setting/components/StaticApprovalFlow/StaticApprovalFlow'
import Modal from '@/components/Modal'
import { Button } from 'antd'
import React, { memo } from 'react'
import styles from './index.module.scss'
interface StrategyDetailModalProps {
  type: PolicyTypeEnum
  record: PolicyItemModel
}
const StrategyDetailModal = memo<StrategyDetailModalProps>(({ type, record }) => {
  const { t } = useTranslation()
  // 判断type
  const isMpc = type === PolicyTypeEnum.MPC_SIGN
  const isSend = type === PolicyTypeEnum.SEND
  const renderFromContent = (currentData: PolicyItemModel) => {
    if (currentData?.fromType === PolicyFromTypeEnum.ANY) {
      return t('policy.any')
    } else if (!currentData?.fromAccountIsAny && currentData?.fromAccountDtoList) {
      const length = currentData?.fromAccountDtoList.length
      const fromAddress = currentData?.fromAccountDtoList
      return (
        <>
          {fromAddress.slice(0, 50).map((item, index) => {
            return (
              <>
                <span key={item.fromAccountKey} style={{ marginRight: '10px' }}>
                  {item.fromAccountName}
                  {index !== length - 1 && <span style={{ marginLeft: '5px' }}>/</span>}
                </span>
                {length > 50 && index === 49 && (
                  <Button
                    type="link"
                    onClick={() => showFromAddress(currentData.fromAccountDtoList!!)}
                    style={{ fontWeight: 'bold' }}
                  >
                    {t('policy.all')}
                  </Button>
                )}
              </>
            )
          })}
        </>
      )
    } else {
      return t('record.allAccout')
    }
  }
  const showFromAddress = (record: FromAccountModel[]) => {
    Modal.info({
      icon: null,
      footer: null,
      title: 'From',
      centered: true,
      content: (
        <div style={{ maxHeight: '600px', overflowY: 'auto', paddingLeft: '10px' }}>
          {record.map((item, index) => {
            const length = record.length
            return (
              <span key={item.fromAccountKey} style={{ marginRight: '10px' }}>
                {item.fromAccountName}
                {index !== length - 1 && <span style={{ marginLeft: '5px' }}>/</span>}
              </span>
            )
          })}
        </div>
      ),
      closable: true,
    })
  }
  const showToAddress = (record: string[]) => {
    Modal.info({
      icon: null,
      footer: null,
      title: 'To',
      centered: true,
      content: (
        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
          {record.map((item, index) => {
            return (
              <div style={{ marginLeft: '10px', marginBottom: '5px' }} key={index}>
                {item}
              </div>
            )
          })}
        </div>
      ),
      closable: true,
    })
  }
  const renderToContent = (currentData: PolicyItemModel) => {
    if (type === PolicyTypeEnum.WEB3 && currentData.toAddressList) {
      const toAddress = currentData.toAddressList
      const length = currentData.toAddressList.length
      return toAddress?.slice(0, 6).map((item, index) => {
        return (
          <div key={index} style={{ marginBottom: '5px' }}>
            {item}
            {length > 6 && index === 5 && (
              <Button
                type="link"
                onClick={() => showToAddress(currentData.toAddressList!!)}
                style={{ fontWeight: 'bold' }}
              >
                {t('policy.all')}
              </Button>
            )}
          </div>
        )
      })
    }
    if (currentData?.toType === PolicyToTypeEnum.ANY) {
      return t('policy.any')
    } else if (currentData?.toType === PolicyToTypeEnum.UNKNOWN) {
      return t('policy.unknown')
    } else if (currentData?.toType === PolicyToTypeEnum.VAULT) {
      return currentData.toAccountIsAny === 1
        ? t('policy.allWallet')
        : currentData.toAccountDtoList?.map(item => {
            return <div key={item.toAccountKey}>{item.toAccountName}</div>
          })
    } else {
      return currentData?.toAccountIsAny === 1
        ? t('policy.allWhite')
        : currentData?.toAccountDtoList?.map(item => {
            return (
              <div key={item.toAccountKey} className={styles.white_item}>
                <header>
                  <span>{item.toAccountName}</span>
                  <ul>
                    <li>{item.blockchainTypeName}</li>
                    <li>{t('common.whiteList')}</li>
                  </ul>
                </header>
                <div>{item.toAddress}</div>
              </div>
            )
          })
    }
  }
  return (
    <>
      <div className={styles.content}>
        {isSend && (
          <div className={styles.items}>
            <div className={styles.label}>{t('policy.condition')}</div>
            <div>{getconditionText(record)}</div>
          </div>
        )}
        <div className={styles.items}>
          <div className={styles.label}>{t('policy.transfer')}</div>
          <div>
            {record?.initiatorIsAny === 1 ? (
              t('policy.allUser')
            ) : (
              <div className={styles.user_list}>
                {record?.initiatorUserDtoList?.map(item => {
                  return (
                    <div className={styles.avatar_name} key={item?.userKey}>
                      <img src={item.userPortrait} alt="" />
                      <span>{item.userName}</span>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>

        <div className={styles.items}>
          <div className={styles.label}>From</div>
          {renderFromContent(record)}
        </div>
        {!isMpc && (
          <div className={styles.items}>
            <div className={styles.label}>To</div>
            {renderToContent(record)}
          </div>
        )}
        <div className={styles.items}>
          <div className={styles.label}>{t('policy.action')}</div>
          {record?.act === PolicyActTypeEnum.ALLOW ? (
            <div> {t('policy.actionRule')}</div>
          ) : (
            <div>{t('policy.actionNone')}</div>
          )}
        </div>
        {record?.act === PolicyActTypeEnum.ALLOW && (
          <div className={styles.items}>
            <div className={styles.label}>{t('common.approval')}</div>
            <StaticApprovalFlow items={record.auditUserRuleDto || []} />
          </div>
        )}
      </div>
    </>
  )
})

export default StrategyDetailModal
